import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const ChooseRoleSignupPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const SIGNUP_ROLES = [
    { key: 'customer', label: t('customer'), subtitle: t('shopper'), desc: t('customerDesc'), icon: '🛍️', color: '#B91C1C', url: '/register/customer' },
    { key: 'merchant', label: t('roleMerchant'), subtitle: t('roleMerchantSub'), desc: t('roleMerchantDesc'), icon: '🏪', color: '#059669', url: '/register/merchant' },
    { key: 'affiliate', label: t('affiliatePartner'), subtitle: t('referralPartner'), desc: t('affiliateDesc'), icon: '💸', color: '#D97706', url: '/register/affiliate', isNew: true },
  ];

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #FFF7ED 0%, #FEF2F2 30%, #EFF6FF 70%, #F0FDF4 100%)' }}>
      <div style={{ padding: '24px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <span style={{ fontSize: '28px', fontWeight: 800, color: '#B91C1C', fontFamily: "'Poppins', sans-serif" }}>
            eBuy<span style={{ color: '#EAB308' }}>Wiz</span>
          </span>
        </Link>
        <span style={{ fontFamily: "'Playfair Display', serif", color: '#B91C1C', fontSize: '18px', fontStyle: 'italic' }}>
          {t('multiVendorMarketplace')}
        </span>
      </div>

      <div style={{ maxWidth: '960px', margin: '0 auto', padding: '0 24px 60px' }}>
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: '36px', fontWeight: 700, color: '#1F2937', marginBottom: '8px' }}>
            {t('joinEbuywiz')}
          </h1>
          <p style={{ color: '#6B7280', fontSize: '16px', marginBottom: '6px' }}>{t('chooseRoleSignUp')}</p>
          <p style={{ color: '#6B7280', fontSize: '14px' }}>
            {t('alreadyHaveAccount')}{' '}
            <Link to="/choose-role" style={{ color: '#B91C1C', fontWeight: 600, textDecoration: 'none' }}>{t('signInLink')}.</Link>
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px' }}>
          {SIGNUP_ROLES.map((role) => (
            <div key={role.key} onClick={() => navigate(role.url)} style={{
              background: '#FFFFFF', borderRadius: '20px', padding: '40px 32px', cursor: 'pointer', transition: 'all 0.3s ease',
              border: '2px solid transparent', boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
              display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', position: 'relative',
            }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.boxShadow = `0 16px 40px ${role.color}18`; e.currentTarget.style.borderColor = `${role.color}30`; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.05)'; e.currentTarget.style.borderColor = 'transparent'; }}
            >
              {role.isNew && (
                <span style={{ position: 'absolute', top: '16px', right: '16px', background: '#EAB308', color: '#FFF', fontSize: '10px', fontWeight: 700, padding: '3px 10px', borderRadius: '20px', letterSpacing: '1px' }}>NEW</span>
              )}
              <div style={{ width: '80px', height: '80px', borderRadius: '24px', background: `${role.color}10`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '42px', marginBottom: '20px' }}>
                {role.icon}
              </div>
              <h3 style={{ fontFamily: "'Poppins', sans-serif", fontSize: '16px', fontWeight: 700, color: role.color, letterSpacing: '0.5px', marginBottom: '4px' }}>
                {role.label}
              </h3>
              <span style={{ fontSize: '13px', color: '#9CA3AF', marginBottom: '12px' }}>{role.subtitle}</span>
              <p style={{ fontSize: '14px', color: '#6B7280', lineHeight: 1.6, marginBottom: '24px', flexGrow: 1 }}>{role.desc}</p>
              <button style={{
                background: role.color, color: '#FFF', border: 'none', padding: '14px 32px', borderRadius: '10px', fontSize: '13px',
                fontWeight: 700, cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '1px', width: '100%',
              }}>
                {t('signUpAs')} {role.label}
              </button>
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: '48px', padding: '24px', background: '#F9FAFB', borderRadius: '16px' }}>
          <p style={{ color: '#6B7280', fontSize: '14px', margin: 0 }}>
            🔒 {t('lookingForOpsRole')}
            <br /><span style={{ fontSize: '13px' }}>{t('opsAccountsCreated')}</span>
          </p>
        </div>
      </div>
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700;800&family=Playfair+Display:ital,wght@0,700;1,700&display=swap" rel="stylesheet" />
    </div>
  );
};

export default ChooseRoleSignupPage;
